import EditRowSidebar from './EditRowSidebar';

export { addAdditionalFieldsToOrder, omitAdditionalFieldsFromOrder } from './utilities';

export default EditRowSidebar;
